// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishListIcon-iconContainer-MH0Tl {
	position: absolute;
	right: 15px;
	top: 15px;
	z-index: 2;
}
.WishListIcon-buttonContainer-nDZUZ {
    text-align: center;
	cursor: pointer;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
    -webkit-column-gap: 4px;
       -moz-column-gap: 4px;
            column-gap: 4px;
}
.WishListIcon-wishListIcon-DcIt1 {
	line-height: 1;
	cursor: pointer;
	width: 100%;
	max-width: 35px;
}
.WishListIcon-buttonContainer-nDZUZ .WishListIcon-wishListIcon-DcIt1 {
	max-width: 20px !important;
}
.WishListIcon-buttonText-qr7wk {
	padding-left: 1px;
}
.WishListIcon-vtrBottom-dZmbq {
	vertical-align: middle;
}
.WishListIcon-vtrMiddle-fL7z5 {
	vertical-align: middle;
}
.WishListIcon-viewListIcon-UoOVR{
	max-width: 20px !important;
    height: 20px;
}
.WishListIcon-iconAlignCenter-pCdR1{
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.WishListIcon-heardIconSize-kLsqF{
	width: 20px;
	height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/WishListIcon/WishListIcon.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,UAAU;AACX;AACA;IACI,kBAAkB;CACrB,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;IACV,uBAAe;OAAf,oBAAe;YAAf,eAAe;AACnB;AACA;CACC,cAAc;CACd,eAAe;CACf,WAAW;CACX,eAAe;AAChB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,iBAAiB;AAClB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,0BAA0B;IACvB,YAAY;AAChB;AACA;CACC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,YAAY;AACb","sourcesContent":[".iconContainer {\n\tposition: absolute;\n\tright: 15px;\n\ttop: 15px;\n\tz-index: 2;\n}\n.buttonContainer {\n    text-align: center;\n\tcursor: pointer;\n\tdisplay: flex;\n    column-gap: 4px;\n}\n.wishListIcon {\n\tline-height: 1;\n\tcursor: pointer;\n\twidth: 100%;\n\tmax-width: 35px;\n}\n.buttonContainer .wishListIcon {\n\tmax-width: 20px !important;\n}\n.buttonText {\n\tpadding-left: 1px;\n}\n.vtrBottom {\n\tvertical-align: middle;\n}\n.vtrMiddle {\n\tvertical-align: middle;\n}\n.viewListIcon{\n\tmax-width: 20px !important;\n    height: 20px;\n}\n.iconAlignCenter{\n\talign-items: center;\n}\n.heardIconSize{\n\twidth: 20px;\n\theight: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContainer": `WishListIcon-iconContainer-MH0Tl`,
	"buttonContainer": `WishListIcon-buttonContainer-nDZUZ`,
	"wishListIcon": `WishListIcon-wishListIcon-DcIt1`,
	"buttonText": `WishListIcon-buttonText-qr7wk`,
	"vtrBottom": `WishListIcon-vtrBottom-dZmbq`,
	"vtrMiddle": `WishListIcon-vtrMiddle-fL7z5`,
	"viewListIcon": `WishListIcon-viewListIcon-UoOVR`,
	"iconAlignCenter": `WishListIcon-iconAlignCenter-pCdR1`,
	"heardIconSize": `WishListIcon-heardIconSize-kLsqF`
};
module.exports = ___CSS_LOADER_EXPORT___;
